import { filter } from "lodash";
import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';
import moment from 'moment';

import { useSelector } from "react-redux";

import { useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap"
import { retry } from "redux-saga/effects";
import { contractWriteResponse, contractWriteHistory, companyListCall, getAllCompanyList, postOutsourcingContractWrite, getMemberSignFile } from "../../crud/auth.crud"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

// import images
import loading from "../../assets/images/loading.gif";

import Modal from "../../components/RopikCustom/Modal";

import coloredCorrespondent from "../../assets/images/svg/correspondent_color.svg"
import SelectBox from "components/RopikCustom/SelectBox";
import Util from "pages/Dashboard/Common/Util";

const style = { backgroundColor: "#ffffff", padding: "0.5rem", cursor: "pointer", width: '466px', border: '1px solid #bdbdbd', marginTop: '0.5rem', borderRadius: '4px', color: '#333' };

const hoverStyle = { backgroundColor: "#4DBBAA", color: "#ffffff", width: '466px', border: '1px solid #4DBBAA' };

const OutsourcingContractWrite = () => {
  const selector = useSelector(state => state)
  const history = useHistory()
  const date = new Date();
  const newDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
  const companyData = selector.auth?.user?.member_group?.[0]?.company_group;

  const [collectionCompanyList, setCollectionCompanyList] = useState([]);
  const [emitterCompanyList, setEmitterCompanyList] = useState([]);
  const [emitterCompanyNameList, setEmitterCompanyNameList] = useState([]);
  const [search, setSearch] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [giveOutsourcing, setGiveOutsourcing] = useState()
  const [takeOutsourcing, setTakeOutsourcing] = useState()
  const [selectedEmitter, setSelectedEmitter] = useState([])
  const [inputItem, setInputItem] = useState({
    emitterList: []
  })
  const [signFile, setSignFile] = useState({})

  const [isHover, setIsHover] = useState(false); // 계약처 선택 시 마우스 호버 상태

  const [modalShow, setModalShow] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [modalShow3, setModalShow3] = useState(false);

  const changeInputCondition = (key, value) => {
    setInputItem(prev => ({ ...prev, [key]: value }))
  }

  const resetInputCondition = () => {
    setInputItem({emitterList: []})
  }

  const isValidated = () => {
    if (!inputItem.subject) {
      alert("제목을 입력해주세요")
      return false
    }
    if (!inputItem.companyFrom) {
      alert('지입주는 업체를 선택해주세요')
      return false
    }
    if (!inputItem.companyTo) {
      alert('지입받는 업체를 선택해주세요')
      return false
    }
    if (!inputItem.startDate || !inputItem.endDate) {
      alert('계약기간을 입력해주세요')
      return false
    }
    // if (imgArr.length === 0) {
    //   return alert('계약서를 등록해주세요')
    // }
    return true
  }

  const handleWrite = async () => {
    setIsLoading(true)

    try {
      const fd = new FormData();

      const emitterData = {
        emitter_list: inputItem.emitterList
      }
      fd.append('emitter_data', JSON.stringify(emitterData))

      const contractData = {
        company_to: inputItem.companyTo,
        company_from: inputItem.companyFrom,
        start_date: inputItem.startDate,
        end_date: inputItem.endDate,
        subject: inputItem.subject,
        content: inputItem.content,
        state: 'N',
        status: 'Y',
      }
      fd.append('contract_data', JSON.stringify(contractData))

      const response = await postOutsourcingContractWrite(fd);
      if (response.data?.result === 'success') {
        setIsLoading(false)
        alert(response.data.msg)
        history.push('/outsourcing-contract-management-screen')
      } else {
        alert(response.data.msg)
        setIsLoading(false)
      }

    } catch (e) {
      setIsLoading(false)
    }
  }

  const getCollectionList = async (search) => {
    setIsLoading(true)
    const params = {
      search: search || '',
      type: 'collection'
    }
    const response = await getAllCompanyList(params)
    if (response?.data?.result === 'success') {
      const content = response?.data?.data?.sort((a, b) => (a.id === companyData.id ? -1 : b.id === companyData.id ? 1 : 0));
      setCollectionCompanyList(content)
    } else {
      setCollectionCompanyList([])
    }
    setIsLoading(false)
  }

  const getEmitterList = async (search) => {
    setIsLoading(true)
    const params = {
      search: search || '',
      type: 'emitter',
    }
    const response = await getAllCompanyList(params)
    if (response?.data?.result === 'success') {
      const content = response?.data?.data
      setEmitterCompanyList(content)
      let companyNameList = []
      content.forEach(v => {
        companyNameList[v.id] = v.name
      })
      setEmitterCompanyNameList(companyNameList)
    } else {
      setEmitterCompanyList([])
      setEmitterCompanyNameList([])
    }
    setIsLoading(false)
  }

  const deleteEmitter = (item) => {
    setInputItem(prev => ({...prev, ['emitterList']: prev['emitterList'].filter(v => v !== item)}))
  }

  const modalClose = () => {
    setModalShow(false)
  }

  const modalClose2 = () => {
    setModalShow2(false)
  }

  const modalClose3 = () => {
    setModalShow3(false)
  }

  const selectEmitterList = (key, value) => {
    setInputItem(prev => ({...prev, [key]: prev[key].includes(value) ? prev[key] : [...prev[key], value]}));
  };

  const getSignFile = async () => {
    setIsLoading(true)
    const response = await getMemberSignFile()
    if (response?.data?.result === 'success') {
      setSignFile(response.data?.data?.[0] || {})
    }
    setIsLoading(false)
  }

  useEffect(() => {
    if (modalShow || modalShow2) {
      getCollectionList()
    }else if(modalShow3){
      getEmitterList()
    }
  }, [modalShow, modalShow2, modalShow3])

  useEffect(() => {
    getCollectionList()
    getEmitterList()
    getSignFile()
  }, [])

  useEffect(() => {
    if (inputItem.companyTo && inputItem.companyTo !== companyData.id) {
      changeInputCondition('companyFrom', companyData.id)
    }
  }, [inputItem.companyTo])

  useEffect(() => {
    if (inputItem.companyFrom && inputItem.companyFrom !== companyData.id) {
      changeInputCondition('companyTo', companyData.id)
    }
  }, [inputItem.companyFrom])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>지입 계약 관리 | 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs maintitle="Home" breadcrumbItem="지입 계약서 관리" />

          <div className="d-flex align-items-center margin-bottom-12">
            <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
            <p className="font-weight-bold font-size-15 mb-0 margin-left-6">계약등록</p>
          </div>

          <Row>
            <Col xs='12'>
              <div className="email-rightbar">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">계약명</td>
                          <td colSpan="6" className="w-40">
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.subject} placeholder="계약명을 입력해 주세요." onChange={(e) => {
                              changeInputCondition('subject', e.target.value)
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">위탁업체명</td>
                          <td className="w-15">
                            <SelectBox
                              value={inputItem?.companyFrom}
                              onChange={changeInputCondition}
                              options={collectionCompanyList}
                              keyValue={'companyFrom'}
                            />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">수탁업체명</td>
                          <td className="w-15">
                            <SelectBox
                              value={inputItem?.companyTo}
                              onChange={changeInputCondition}
                              options={collectionCompanyList}
                              keyValue={'companyTo'}
                            />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">계약기간</td>
                          <td className="w-40">
                            <input className="waver-input-box w-40 border-radius-0 margin-right-4" type="date" value={inputItem.startDate} onChange={(e) => {
                              changeInputCondition('startDate', e.target.value);
                            }} />
                            <input className="waver-input-box w-40 border-radius-0" type="date" value={inputItem.endDate} onChange={(e) => {
                              changeInputCondition('endDate', e.target.value);
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">할당할 배출자</td>
                          <td className="w-15">
                            <SelectBox
                              value={''}
                              onChange={selectEmitterList}
                              options={emitterCompanyList}
                              keyValue={'emitterList'}
                            />
                          </td>
                          <td colSpan="4">
                            <div style={{display: 'flex', flexWrap: 'wrap'}}>
                              {inputItem.emitterList.map((item, index) => {
                                return (
                                  <div key={'emitter_company_' + index} style={{ minWidth: 113, height: 30, marginRight: 8, backgroundColor: '#219EBC', display: 'flex', justifyContent: "space-between", paddingLeft: 11, paddingRight: 11, alignItems: "center", gap: 8 }}>
                                    <p className="noMargin" style={{color: "white", lineHeight: '100%' }}>{emitterCompanyNameList[item]}</p>
                                    <p className="noMargin" style={{color: "white", cursor: "pointer", lineHeight: '100%' }} onClick={() => {
                                      deleteEmitter(item)
                                    }}>X</p>
                                  </div>
                                )
                              })
                              }
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">계약내용</td>
                          <td colSpan="6" className="w-40">
                            <textarea className="waver-text-box w-100 font-size-12 border-radius-0" placeholder="내용을 입력해 주세요" value={inputItem.content}
                              onChange={(e) => {
                                changeInputCondition('content', e.target.value);
                              }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">위탁업체 직인</td>
                          <td className="w-15">
                            {signFile.path && inputItem?.companyFrom == companyData.id &&
                              <img src={Util.addHostUrl(signFile?.path)} />
                            }
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">수탁업체 직인</td>
                          <td className="w-15">
                            {signFile.path && inputItem?.companyTo == companyData.id &&
                              <img src={Util.addHostUrl(signFile?.path)} />
                            }
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text"></td>
                          <td className="w-40"></td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <div style={{ marginTop: 310 }} className="d-flex justify-content-between margin-bottom-25">
            <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 dark-bg white-text button-border" onClick={() => { history.push('/outsourcing-contract-management-screen') }}>
              목록으로 이동
            </button>
            <div className="d-flex">
              <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 primary-bg white-text button-border" onClick={() => {
                if (isValidated()) {
                  handleWrite()
                }
              }}>
                지입계약 등록
              </button>
              <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 white-bg primary-text button-border" onClick={() => {
                if (confirm('입력을 초기화 하시겠습니까?')) {
                  resetInputCondition()
                }
              }}>
                입력 초기화
              </button>
            </div>
          </div>

          {/* <Modal title={'지입주는 업체 선택'} show={modalShow} onHide={modalClose} size="md">
            <div style={{ zIndex: 1, minHeight: '300px' }}>
              <div className="position-relative app-search d-none d-lg-block" style={{ padding: 0, width: 330, marginBottom: "1rem" }}>
                <input
                  className="form-control"
                  style={{ backgroundColor: "white", padding: "0.3rem" }}
                  placeholder="검색어를 입력해주세요..."
                  onChange={(e) => {
                    setSearch(e.target.value.length == 0 ? '' : e.target.value)
                  }}
                  onKeyPress={(e) => {
                    if (e.key == 'Enter') {
                      getCollectionList(search)
                    }
                  }}
                />
                <span onClick={() => {
                  getCollectionList(search)
                }} className="fa fa-search" style={{ lineHeight: '38px', cursor: 'pointer' }} />
              </div>
              <div style={{ position: "relative", minHeight: '300px', overflowY: "auto" }}>
                <div style={{ position: "absolute", minHeight: '300px', right: 0, left: 0, overflowX: "hidden" }}>
                  <div style={isHover == 'me' ? { ...style, ...hoverStyle } : { ...style }}
                    onMouseOver={() => {
                      setIsHover('me')
                    }}
                    onMouseLeave={() => {
                      setIsHover(false)
                    }}
                    onClick={() => {
                      setGiveOutsourcing(companyData)
                      modalClose()
                      if (companyData.id === takeOutsourcing?.id) {
                        setTakeOutsourcing()
                      }
                    }}>{'<<나>>'}
                  </div>
                  {collectionCompanyList && collectionCompanyList.map((item) => {
                    return (
                      <div style={isHover == item.id ? { ...style, ...hoverStyle } : { ...style }} key={item.id}
                        onMouseOver={() => {
                          setIsHover(item.id)
                        }}
                        onMouseLeave={() => {
                          setIsHover(false)
                        }}
                        onClick={() => {
                          setGiveOutsourcing(item)
                          modalClose()
                          setTakeOutsourcing(companyData)
                        }}>{item.name}
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
            {isLoading && <div style={{
              position: "absolute",
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              background: 'rgba(255, 255, 255, 0.6)',
              zIndex: 999,
              display: "flex",
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <img src={loading} alt="로딩중입니다." width={'5%'}></img>
            </div>}
          </Modal>
          <Modal title={'지입받는 업체 선택'} show={modalShow2} onHide={modalClose2} size="md">
            <div style={{ zIndex: 1, minHeight: '300px' }}>
              <div className="position-relative app-search d-none d-lg-block" style={{ padding: 0, width: 330, marginBottom: "1rem" }}>
                <input
                  className="form-control"
                  style={{ backgroundColor: "white", padding: "0.3rem" }}
                  placeholder="검색어를 입력해주세요..."
                  onChange={(e) => {
                    setSearch(e.target.value.length == 0 ? '' : e.target.value)
                  }}
                  onKeyPress={(e) => {
                    if (e.key == 'Enter') {
                      getCollectionList(search)
                    }
                  }}
                />
                <span onClick={() => {
                  getCollectionList(search)
                }} className="fa fa-search" style={{ lineHeight: '38px', cursor: 'pointer' }} />
              </div>
              <div style={{ position: "relative", minHeight: '300px', overflowY: "auto" }}>
                <div style={{ position: "absolute", minHeight: '300px', right: 0, left: 0, overflowX: "hidden" }}>
                  <div style={isHover == 'me' ? { ...style, ...hoverStyle } : { ...style }}
                    onMouseOver={() => {
                      setIsHover('me')
                    }}
                    onMouseLeave={() => {
                      setIsHover(false)
                    }}
                    onClick={() => {
                      setTakeOutsourcing(companyData)
                      modalClose2()
                      if (companyData.id === giveOutsourcing?.id) {
                        setGiveOutsourcing()
                      }
                    }}>{'<<나>>'}
                  </div>
                  {collectionCompanyList && collectionCompanyList.map((item) => {
                    return (
                      <div style={isHover == item.id ? { ...style, ...hoverStyle } : { ...style }} key={item.id}
                        onMouseOver={() => {
                          setIsHover(item.id)
                        }}
                        onMouseLeave={() => {
                          setIsHover(false)
                        }}
                        onClick={() => {
                          setTakeOutsourcing(item)
                          modalClose2()
                          setGiveOutsourcing(companyData)
                        }}>{item.name}
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
            {isLoading && <div style={{
              position: "absolute",
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              background: 'rgba(255, 255, 255, 0.6)',
              zIndex: 999,
              display: "flex",
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <img src={loading} alt="로딩중입니다." width={'5%'}></img>
            </div>}
          </Modal>
          <Modal title={'할당할 배출자 선택'} show={modalShow3} onHide={modalClose3} size="md" >
            <div style={{ zIndex: 1, }}>
              <div className="position-relative app-search d-none d-lg-block" style={{ padding: 0, width: 330, marginBottom: "1rem" }}>
                <input
                  className="form-control"
                  style={{ backgroundColor: "white", padding: "0.3rem" }}
                  placeholder="검색어를 입력해주세요..."
                  onChange={(e) => {
                    setSearch(e.target.value.length == 0 ? '' : e.target.value)
                  }}
                  onKeyPress={(e) => {
                    if (e.key == 'Enter') {
                      getEmitterList(search)
                    }
                  }}
                />
                <span onClick={() => {
                  getEmitterList(search)
                }} className="fa fa-search" style={{ lineHeight: '38px', cursor: 'pointer' }} />
              </div>

              <div style={{ position: "relative", minHeight: '300px', overflowY: "auto" }}>
                <div style={{ position: "absolute", minHeight: '300px', right: 0, left: 0, overflowX: "hidden" }}>
                  {emitterCompanyList && emitterCompanyList.map((item) => {
                    return (
                      <div style={isHover == item.id ? { ...style, ...hoverStyle } : { ...style }} key={item.id}
                        onMouseOver={() => {
                          setIsHover(item.id)
                        }}
                        onMouseLeave={() => {
                          setIsHover(false)
                        }}
                        onClick={() => {
                          setSelectedEmitter([...selectedEmitter, selectedEmitter.map(item => { return item.name }).indexOf(item.name) == -1 && item].filter(item => item != false))
                          modalClose3()
                        }}>{item.name}
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
            {isLoading && <div style={{
              position: "absolute",
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              background: 'rgba(255, 255, 255, 0.6)',
              zIndex: 999,
              display: "flex",
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <img src={loading} alt="로딩중입니다." width={'5%'}></img>
            </div>}
          </Modal> */}

        </Container>
      </div>
    </React.Fragment>
  )
}

export default OutsourcingContractWrite
